import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ClientAdministrationFormType } from './client-administration-edit-form';
import { TranslatePipe } from '@ngx-translate/core';
import { YesNoGroupButtonComponent } from '../../../../base/shared/yes-no-group-button/yes-no-group-button.component';

import { AppErrorMessagesComponent } from '../../../../base/error-messages/app-error-messages.component';

@Component({
    selector: 'app-client-administration-edit-form',
    templateUrl: './client-administration-edit-form.component.html',
    styleUrls: ['./client-administration-edit-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ReactiveFormsModule, AppErrorMessagesComponent, YesNoGroupButtonComponent, TranslatePipe]
})
export class ClientAdministrationEditFormComponent {

  @Input() public clientEditForm: FormGroup<ClientAdministrationFormType> | null = null;

  public get isEdit(): boolean {
    return !!this.clientEditForm?.get('id')?.value;
  }

  constructor() { }
}
